import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { CSVLink } from "react-csv";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import SheetOneLoader from "./SheetOneLoader";
import { BrandsTypes, toLakhs } from "../../../utils/constants";
import useCategories from '../useCategories'
const SheetOnePreview = () => {
  const getDefaultDateRange = (last = 0) => {
    const end = new Date();
    const start = new Date();
    if(last) {
       start.setFullYear(start.getFullYear()-1);
       end.setFullYear(end.getFullYear()-1);
    }
    start.setMonth(start.getMonth() - 5);
    start.setDate(1);
    end.setDate(1);
    return [start, end];
  };

  const [dateRange1, setDateRange1] = useState(getDefaultDateRange());
  const [dateRange2, setDateRange2] = useState(getDefaultDateRange(1));
  const [data1, setData1] = useState({});
  const [data2, setData2] = useState({});
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState([]);
  const [salesPersons, setSalesPersons] = useState([]);
  const [selectedBrandType, setSelectedBrandType] = useState(2);
  const [locations, setLocations] = useState([]);

  const isLoading = isLoading1 || isLoading2;
  const {CategorySelect, selectedCategories} = useCategories()
  useEffect(() => {
    const fetchLocations = async () => {
      const result = await API({ url: "/phionex_reports/brandLocations", method: "POST" });
      if (result.status === "SUCCESS") setLocations(result.data);
      else Toast(result.message);
    };
    fetchLocations();
  }, []);

  const formatDateRangeForAPI = (range) => {
    if (!range || !range[0] || !range[1]) return null;
    const startStr = `${range[0].getFullYear()}-${String(range[0].getMonth() + 1).padStart(2, "0")}`;
    const endStr = `${range[1].getFullYear()}-${String(range[1].getMonth() + 1).padStart(2, "0")}`;
    return [startStr, endStr];
  };

  useEffect(() => {
    if (!dateRange1[0] || !dateRange1[1]) return;
    setIsLoading1(true);
    const apiDateRange = formatDateRangeForAPI(dateRange1);
    if (!apiDateRange) return;
    API({
      url: "/phionex_reports/getSheet1Data",
      method: "POST",
      data: { dateRange: apiDateRange, brand_type: selectedBrandType, sales_person: selectedSalesPerson,selectedCategories },
    })
      .then((r) => {
        if (r.status === "SUCCESS") setData1(r.data);
        else Toast("error", r.message || "Failed To Fetch Data");
      })
      .catch(() => {
        Toast("error", "An error occurred");
      })
      .finally(() => setIsLoading1(false));
  }, [dateRange1, selectedBrandType, selectedSalesPerson, selectedCategories]);

  useEffect(() => {
    if (!dateRange2 || !dateRange2[0] || !dateRange2[1]) {
      setData2({});
      return;
    }
    setIsLoading2(true);
    const apiDateRange = formatDateRangeForAPI(dateRange2);
    if (!apiDateRange) return;
    API({
      url: "/phionex_reports/getSheet1Data",
      method: "POST",
      data: { dateRange: apiDateRange, brand_type: selectedBrandType, sales_person: selectedSalesPerson,selectedCategories },
    })
      .then((r) => {
        if (r.status === "SUCCESS") setData2(r.data);
        else Toast("error", r.message || "Failed To Fetch Data");
      })
      .catch(() => {
        Toast("error", "An error occurred");
      })
      .finally(() => setIsLoading2(false));
  }, [dateRange2, selectedBrandType, selectedSalesPerson, selectedCategories]);

  useEffect(() => {
    // if (!selectedBrandType) {
    //   setSalesPersons([]);
    //   setSelectedSalesPerson([]);
    //   return;
    // }
    const getSalesPersons = async () => {
      const result = await API({
        url: "/phionex_reports/getSalesPersons",
        method: "POST",
        data: { selectedBrandType },
      });
      if (result.status === "SUCCESS") setSalesPersons(result.data);
      else Toast("error", result.message);
    };
    getSalesPersons();
  }, []);

  const formatRange = (range) => {
    if (!range || !range[0] || !range[1]) return "";
    const startMonth = range[0].toLocaleString("default", { month: "short" });
    const endMonth = range[1].toLocaleString("default", { month: "short" });
    const startYear = range[0].getFullYear();
    const endYear = range[1].getFullYear();
    if (startYear === endYear) {
      return `${startMonth}-${endMonth} ${startYear}`;
    } else {
      return `${startMonth} ${startYear}-${endMonth} ${endYear}`;
    }
  };

  const getStats = (data, location) => {
    let eenaduRev = 0,
      eenaduBrands = 0,
      w2nRev = 0,
      w2nBrands = 0,
      otherRev = 0,
      otherBrands = 0;

    const keys = { Eenadu: "Eenadu", W2N: "W2N", Other: "Other" };

    if (location === "Total") {
      if (data[keys.Eenadu])
        data[keys.Eenadu].forEach((item) => {
          eenaduRev += parseFloat(item.amount || 0);
          eenaduBrands += parseInt(item.brand_count || 0);
        });
      if (data[keys.W2N])
        data[keys.W2N].forEach((item) => {
          w2nRev += parseFloat(item.amount || 0);
          w2nBrands += parseInt(item.brand_count || 0);
        });
      if (data[keys.Other])
        data[keys.Other].forEach((item) => {
          otherRev += parseFloat(item.amount || 0);
          otherBrands += parseInt(item.brand_count || 0);
        });
    } else {
      const eenaduItem = data[keys.Eenadu]?.find((i) => i.location === location);
      if (eenaduItem) {
        eenaduRev = parseFloat(eenaduItem.amount || 0);
        eenaduBrands = parseInt(eenaduItem.brand_count || 0);
      }
      const w2nItem = data[keys.W2N]?.find((i) => i.location === location);
      if (w2nItem) {
        w2nRev = parseFloat(w2nItem.amount || 0);
        w2nBrands = parseInt(w2nItem.brand_count || 0);
      }
      const otherItem = data[keys.Other]?.find((i) => i.location === location);
      if (otherItem) {
        otherRev = parseFloat(otherItem.amount || 0);
        otherBrands = parseInt(otherItem.brand_count || 0);
      }
    }

    const percentRev = eenaduRev > 0 ? ((w2nRev / eenaduRev) * 100).toFixed(1) + "%" : "0.0%";
    const percentBrands = eenaduBrands > 0 ? ((w2nBrands / eenaduBrands) * 100).toFixed(1) + "%" : "0.0%";
    const overallRev = w2nRev + otherRev;
    const overallBrands = w2nBrands + otherBrands;

    return {
      eenaduRev,
      eenaduBrands,
      w2nRev,
      w2nBrands,
      percentRev,
      percentBrands,
      otherRev,
      otherBrands,
      overallRev,
      overallBrands,
    };
  };

  const TableComponent = ({ stats1, stats2, location, period1, period2 }) => {
    const hasComparison = !!stats2;
    return (
      <div className="flex items-start justify-start gap-3">
        <span className="inline-block w-40 px-2 py-1 bg-yellow-300 font-bold shadow mb-3 text-center">{location}</span>
        <table className="w-full border border-gray-300 bg-white shadow rounded-lg">
          <thead>
            <tr>
              <th className="border p-2"></th>
              <th colSpan={2} className="border p-2 text-center bg-red-200">
                {period1}
              </th>
              {hasComparison && (
                <th colSpan={2} className="border bg-green-200 p-2 text-center">
                  {period2}
                </th>
              )}
            </tr>
            <tr>
              <th className="border p-2"></th>
              <th className="border p-2 text-center bg-red-200">Rev</th>
              <th className="border p-2 text-center bg-red-200">Brands</th>
              {hasComparison && <th className="border bg-green-200 p-2">Rev</th>}
              {hasComparison && <th className="border bg-green-200 p-2">Brands</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={hasComparison ? 5 : 3} className="border bg-yellow-100 p-2 font-bold">
                Eenadu World
              </td>
            </tr>
            <tr>
              <td className="border p-2 pl-4">Eenadu</td>
              <td className="border p-2" title={stats1.eenaduRev}>{toLakhs(stats1.eenaduRev)}</td>
              <td className="border p-2" title={stats1.eenaduBrands}>{stats1.eenaduBrands}</td>
              {hasComparison && <td className="border p-2" title={stats2.eenaduRev}>{toLakhs(stats2.eenaduRev)}</td>}
              {hasComparison && <td className="border p-2" title={stats2.eenaduBrands}>{stats2.eenaduBrands}</td>}
            </tr>
            <tr>
              <td className="border p-2 pl-4">Way2News</td>
              <td className="border p-2" title={stats1.w2nRev}>{toLakhs(stats1.w2nRev)}</td>
              <td className="border p-2" title={stats1.w2nBrands}>{stats1.w2nBrands}</td>
              {hasComparison && <td className="border p-2" title={stats2.w2nRev}>{toLakhs(stats2.w2nRev)}</td>}
              {hasComparison && <td className="border p-2" title={stats2.w2nBrands}>{stats2.w2nBrands}</td>}
            </tr>
            <tr>
              <td className="border p-2 pl-4">%</td>
              <td className="border p-2">{stats1.percentRev}</td>
              <td className="border p-2">{stats1.percentBrands}</td>
              {hasComparison && <td className="border p-2">{stats2.percentRev}</td>}
              {hasComparison && <td className="border p-2">{stats2.percentBrands}</td>}
            </tr>
            <tr>
              <td colSpan={hasComparison ? 5 : 3} className="border bg-yellow-100 p-2 font-bold">
                Non Eenadu World
              </td>
            </tr>
            <tr>
              <td className="border p-2 pl-4">Outside E</td>
              <td className="border p-2" title={stats1.otherRev}>{toLakhs(stats1.otherRev)}</td>
              <td className="border p-2" title={stats1.otherBrands}>{stats1.otherBrands}</td>
              {hasComparison && <td className="border p-2" title={stats2.otherRev}>{toLakhs(stats2.otherRev)}</td>}
              {hasComparison && <td className="border p-2" title={stats2.otherBrands}>{stats2.otherBrands}</td>}
            </tr>
            <tr>
              <td className="border p-2 pl-4">Overall</td>
              <td className="border p-2" title={stats1.overallRev}>{toLakhs(stats1.overallRev)}</td>
              <td className="border p-2" title={stats1.overallBrands}>{stats1.overallBrands}</td>
              {hasComparison && <td className="border p-2" title={stats2.overallRev}>{toLakhs(stats2.overallRev)}</td>}
              {hasComparison && <td className="border p-2" title={stats2.overallBrands}>{stats2.overallBrands}</td>}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const period1 = formatRange(dateRange1);
  const period2 = formatRange(dateRange2);

  let allLocations = new Set();
  const addLocations = (data) => {
    ["Eenadu", "W2N", "Other"].forEach((key) => {
      data[key]?.forEach((item) => {
        if (parseFloat(item.amount) > 0 || parseInt(item.brand_count) > 0) {
          allLocations.add(item.location);
        }
      });
    });
  };
  addLocations(data1);
  if (data2 && Object.keys(data2).length > 0) {
    addLocations(data2);
  }

  let locationsToShow = Array.from(allLocations).sort();
  if (selectedLocation) {
    locationsToShow = allLocations.has(selectedLocation) ? [selectedLocation] : [];
  }

  const sections = ["Total", ...locationsToShow];

  const csvHeaders = data2 && Object.keys(data2).length > 0 ? [["Brand", `${period1} Rev`, `${period1} Brands`, `${period2} Rev`, `${period2} Brands`]] : [["Brand", `${period1} Rev`, `${period1} Brands`]];

  const csvBody = [];
  sections.forEach((section) => {
    const stats1 = getStats(data1, section);
    const stats2 = data2 && Object.keys(data2).length > 0 ? getStats(data2, section) : null;
    csvBody.push([section]);
    csvBody.push(["Eenadu World"]);
    csvBody.push(["Eenadu", stats1.eenaduRev, stats1.eenaduBrands, stats2 ? stats2.eenaduRev : "", stats2 ? stats2.eenaduBrands : ""]);
    csvBody.push(["Way2News", stats1.w2nRev, stats1.w2nBrands, stats2 ? stats2.w2nRev : "", stats2 ? stats2.w2nBrands : ""]);
    csvBody.push(["%", stats1.percentRev, stats1.percentBrands, stats2 ? stats2.percentRev : "", stats2 ? stats2.percentBrands : ""]);
    csvBody.push(["Non Eenadu World"]);
    csvBody.push(["Outside E", stats1.otherRev, stats1.otherBrands, stats2 ? stats2.otherRev : "", stats2 ? stats2.otherBrands : ""]);
    csvBody.push(["Overall", stats1.overallRev, stats1.overallBrands, stats2 ? stats2.overallRev : "", stats2 ? stats2.overallBrands : ""]);
    csvBody.push([]);
  });

  const csvData = [...csvHeaders, ...csvBody];

  const clearDateRange2 = () => {
    setDateRange2(null);
    setData2({});
  };

  return (
    <div className="p-4 max-w-full">
      <div className="flex flex-wrap gap-6 items-end rounded px-4 py-2 bg-white">
        <div className="flex flex-col">
          <label className="mb-1 font-semibold">Select Date Range 1 *</label>
          <DatePicker
            selected={dateRange1[0]}
            onChange={setDateRange1}
            startDate={dateRange1[0]}
            endDate={dateRange1[1]}
            selectsRange
            dateFormat="MM/yyyy"
            showMonthYearPicker
            className="border rounded px-3 py-2 w-48"
            maxDate={new Date()}
            placeholderText="Select Month & Year"
          />
        </div>
        <div className="flex flex-col relative">
          <label className="mb-1 font-semibold">Select Date Range 2</label>
          <DatePicker
            selected={dateRange2?.[0] || null}
            onChange={(update) => {
              setDateRange2(update);
            }}
            startDate={dateRange2?.[0] || null}
            endDate={dateRange2?.[1] || null}
            selectsRange
            dateFormat="MM/yyyy"
            showMonthYearPicker
            className="border rounded px-3 py-2 w-48"
            maxDate={new Date()}
            placeholderText="Select Month & Year"
            openToDate={dateRange2?.[0] || new Date()}
          />
          {dateRange2 && (
            <button onClick={clearDateRange2} className="absolute right-0 top-10 text-gray-500 hover:text-gray-700" type="button">
              ×
            </button>
          )}
        </div>
        <div className="flex flex-col min-w-[180px]">
          <label className="mb-1 font-semibold">Select Location</label>
          <Select
            options={locations}
            value={locations.find((l) => l.value === selectedLocation) || null}
            onChange={(item) => setSelectedLocation(item?.value || null)}
            placeholder="Select Location"
            isClearable
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
        <div className="flex flex-col min-w-[180px]">
          <label className="mb-1 font-semibold">Select Brand Type</label>
          <Select
            options={BrandsTypes}
            value={BrandsTypes.find((b) => +b.value === +selectedBrandType) || null}
            onChange={(item) => setSelectedBrandType(item?.value || null)}
            placeholder="Select Brand Type"
            isClearable
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
        <div className={`flex flex-col min-w-[220px] ${selectedBrandType ? "" : "opacity-50 pointer-events-none"}`}>
          <label className="mb-1 font-semibold">Select Sales Person(s)</label>
          <Select
            options={salesPersons}
            value={salesPersons.filter((p) => selectedSalesPerson.includes(+p.value))}
            onChange={(items) => setSelectedSalesPerson(items ? items.map((i) => i.value) : [])}
            isMulti
            isClearable
            placeholder="Select Sales Person(s)"
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            closeMenuOnSelect={false}
          />
        </div>
        <CategorySelect />
        <CSVLink data={csvData} filename="sheet_one_data.csv" className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded">
          Download CSV
        </CSVLink>
      </div>
      <div className="mt-6">
        {isLoading ? (
          <SheetOneLoader />
        ) : (
          sections.map((section) => {
            const stats1 = getStats(data1, section);
            const stats2 = data2 && Object.keys(data2).length > 0 ? getStats(data2, section) : null;
            return (
              <div key={section} className="mb-8">
                <TableComponent stats1={stats1} stats2={stats2} location={section} period1={period1} period2={period2} />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SheetOnePreview;